import { Badge } from "@/components/ui/badge";
import { Trophy, Award, Medal } from "lucide-react";

type Tier = 'Gold' | 'Silver' | 'Bronze';

interface TierBadgeProps {
  tier: Tier;
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
  className?: string;
}

const tierConfig = {
  Gold: {
    bg: 'bg-yellow-100 dark:bg-yellow-900/30',
    text: 'text-yellow-800 dark:text-yellow-300',
    border: 'border-yellow-300 dark:border-yellow-700',
    icon: Trophy,
    iconColor: 'text-yellow-600 dark:text-yellow-400'
  },
  Silver: {
    bg: 'bg-gray-100 dark:bg-gray-800',
    text: 'text-gray-800 dark:text-gray-300',
    border: 'border-gray-300 dark:border-gray-700',
    icon: Award,
    iconColor: 'text-gray-600 dark:text-gray-400'
  },
  Bronze: {
    bg: 'bg-orange-100 dark:bg-orange-900/30',
    text: 'text-orange-800 dark:text-orange-300',
    border: 'border-orange-300 dark:border-orange-700',
    icon: Medal,
    iconColor: 'text-orange-600 dark:text-orange-400'
  }
};

export function TierBadge({ tier, size = 'md', showIcon = true, className = '' }: TierBadgeProps) {
  const config = tierConfig[tier];
  const Icon = config.icon;
  
  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-1',
    lg: 'text-base px-3 py-1.5'
  };

  return (
    <Badge 
      className={`${config.bg} ${config.text} ${config.border} border ${sizeClasses[size]} font-medium flex items-center gap-1.5 ${className}`}
    >
      {showIcon && <Icon className={`h-3 w-3 ${config.iconColor} ${size === 'lg' ? 'h-4 w-4' : ''}`} />}
      <span>{tier}</span>
    </Badge>
  );
}

